module.exports = __webpack_public_path__ + "static/media/contact.07ab0bb7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/contact.gif
// module id = ./src/assets/Home/contact.gif
// module chunks = 0